// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_36ky9W7x_aoncpLvpf7iUA","grey":"_2TdLDQanUVR6wimkg8LnbG"};